import { GetCatchRanking, SendCatchAdminControl, EditCatchPlayer, SendCatchScreenCommand, GetAllCatchPlayers, ResetAllCatchScores, SubmitManualCatchScore, GiveSecondChance } from './../DL/CatchTheBall';
import SignalRService from '../WS/SignalRService';

let catchMessageHandler = null;
let catchReconnectedHandler = null;

// ==========================================================================
// 🔌 SIGNALR (Solo para escuchar cuándo la pantalla gigante termina el juego)
// ==========================================================================
const ConnectCatchTheBallWebSocket = async (onStatus = () => {}, onMessage = () => {}) => {
    onStatus('connecting');

    catchMessageHandler = (envelope) => {
        if (envelope && envelope.type && envelope.type.toLowerCase() === 'catchtheball') {
            onMessage(envelope.data ?? envelope.payload); // Pasamos el action y payload
        }
    };

    catchReconnectedHandler = () => {
        onStatus('connected');
    };

    SignalRService.on('message', catchMessageHandler);
    SignalRService.on('reconnected', catchReconnectedHandler);

    SignalRService.connect({ tipo: 'catchtheball:gamepad' })
        .then(() => {
            onStatus('connected');
        })
        .catch(() => {
            onStatus('disconnected');
        });
};

const DisconnectCatchTheBallWebSocket = () => {
    if (catchMessageHandler) {
        SignalRService.off('message', catchMessageHandler);
        catchMessageHandler = null;
    }
    if (catchReconnectedHandler) {
        SignalRService.off('reconnected', catchReconnectedHandler);
        catchReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

// ==========================================================================
// 📡 REST API (Peticiones del Gamepad)
// ==========================================================================
const JoinCatchTheBallGame = async (userData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Join`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData)
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

// Función ultrarrápida (fire-and-forget) para no trabar el celular
const SendGamepadCommand = (commandStr) => {
    fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Gamepad`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ command: commandStr })
    }).catch(() => {}); // Ignoramos errores de red para no frenar la experiencia
};


//--- Admin ---//

const GetRankingBL = async () => await GetCatchRanking();
const EditPlayerBL = async (id, nickname, isCensored) => await EditCatchPlayer(id, nickname, isCensored);
const SendScreenCommandBL = async (commandStr, payload = null) => await SendCatchScreenCommand(commandStr, payload);
const AdminControlBL = async (actionStr, durationValue = null) => await SendCatchAdminControl(actionStr, durationValue);

const GetAllPlayersBL = async () => await GetAllCatchPlayers();
const ResetAllScoresBL = async () => await ResetAllCatchScores();
const SubmitManualScoreBL = async (userData) => await SubmitManualCatchScore(userData);
const GiveSecondChanceBL = async (userData) => await GiveSecondChance(userData);

//--- Admin ---//

export { ConnectCatchTheBallWebSocket, DisconnectCatchTheBallWebSocket, JoinCatchTheBallGame, SendGamepadCommand, GetRankingBL, EditPlayerBL, SendScreenCommandBL, AdminControlBL, GetAllPlayersBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL };